import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { delay } from 'rxjs';

@Component({
  selector: 'app-data-empty-animation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './data-empty-animation.component.html',
  styleUrl: './data-empty-animation.component.scss'
})
export class DataEmptyAnimationComponent {
  @Input() width: string = '100%';
  @Input() height: string = '1rem';
  dots: { top: number; left: number }[] = [];

  constructor(private elRef: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit(): void {
    const container = this.elRef.nativeElement.querySelector('.dot-wrapper');
    const containerRect = container.getBoundingClientRect();
    const cols = Math.floor(containerRect.width);
    const rows = Math.floor(containerRect.height);

    anime({
      targets: '#q-mark',
      opacity: [0, 0.5],
      easing: 'easeInOutSine',
      duration: 1000,
      delay: 1000,
    });

    const dotSize = 6;

    for (let y = 0; y < rows; y += dotSize) {
      for (let x = 0; x < cols; x += dotSize) {
        this.dots.push({ top: y, left: x });
      }
    }

    // Let Angular finish rendering the dots, then animate
    setTimeout(() => {
      this.animateDots();
    }, 200);
  }

  animateDots() {
    const allDots = this.elRef.nativeElement.querySelectorAll('.ghost-dot');

    anime({
      targets: '#d-wrap',
      opacity: [0, 1],
      duration: 10000,
      delay: 1000,
    });

    allDots.forEach((dot: HTMLElement) => {
      anime({
        targets: dot,
        opacity: [
          { value: 0.2, duration: 1000 },
          { value: 1, duration: 1000 }
        ],
        easing: 'easeInOutSine',
        delay: anime.random(0, 2000),
        loop: true,
        direction: 'alternate'
      });
    });
  }

}
